import React from 'react'
import { Select } from 'antd'

import CustomInput from '../../../components/Input/Input'

import { labelClassNames } from './index'
import { LOCKBOX_STATUS_OPTIONS } from '../utils'

let timeOut = null

function LockBoxFields (props) {
  const { filters, setFilters, searchValue, setSearchValue } = props

  return (
    <>
      <div className="w-[200px]">
        <div className={labelClassNames}>
          Search lockBox
        </div>

        <CustomInput
          placeholder="Search"
          value={searchValue}
          allowClear
          onChange={(e) => {
            setSearchValue(e.target.value)

            if (timeOut) {
              clearTimeout(timeOut)
            }
            timeOut = setTimeout(() => {
              setFilters(prev => ({
                ...prev,
                search: e.target.value
              }))
            }, 600)
          }}
        />
      </div>

      <div className="w-[200px]">
        <div className={labelClassNames}>
          LockBox status
        </div>

        <Select
          className="w-full"
          placeholder="Select status"
          options={LOCKBOX_STATUS_OPTIONS}
          value={filters.status}
          onChange={value => {
            setFilters(prev => ({ ...prev, status: value }))
          }}
          allowClear
        />
      </div>
    </>
  )
}

export default LockBoxFields